import { HELP_CENTER as o, SEARCH_RESULT_CLICKED as a } from "./help-center-articles-search22.js";
import { getIndexName as c } from "./help-center-articles-search21.js";
function s(e) {
  const { searchSelectedItem: t, ...n } = e, r = {
    ...n,
    label: t.trackingLabel,
    category: "Internal Search",
    sectionName: o,
    hasTypo: ((t._rankingInfo?.nbTypos ?? 0) > 0).toString(),
    resultIndex: c(e.locale, e.environment),
    resultId: t.objectID,
    searchTerm: e.query
  };
  return {
    eventName: a,
    data: r
  };
}
export {
  s as getSearchResultClickedTrackingData
};
//# sourceMappingURL=help-center-articles-search15.js.map
